import { Directive, EventEmitter, Input, Output } from '@angular/core';

export type SortColumn = keyof any | '';
export type SortDirection = 'asc' | 'desc' | '';

const rotate: {[key: string]: SortDirection} = { 'asc': 'desc', 'desc': 'asc' };


export interface SortEvent {
  column: SortColumn;
  direction?: SortDirection;
}
@Directive({
  selector: 'th[sortable]',
  host: {
    '[class.asc]': 'direction === "asc"',
    '[class.desc]': 'direction === "desc"',
    '(click)': 'rotate()'
  }
})
export class SortableHeaderDirective {

  @Input() sortable: SortColumn = '';
  @Input() direction: SortDirection = '';
  @Input() default: SortDirection;

  @Output() sort = new EventEmitter<SortEvent>();

  rotate() {
    if (this.direction === '' && this.default) {
      this.direction = this.default;
      this.default = undefined;
    } else if (this.direction === '' && this.default === undefined) {
      this.direction = 'desc';
    }

    this.direction = rotate[this.direction];
    this.sort.emit({column: this.sortable, direction: this.direction});
  }
}
